import { render, staticRenderFns } from "./PrettyDescription.vue?vue&type=template&id=3b727b4f"
import script from "./PrettyDescription.vue?vue&type=script&lang=js"
export * from "./PrettyDescription.vue?vue&type=script&lang=js"
import style0 from "./PrettyDescription.vue?vue&type=style&index=0&id=3b727b4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports